import {
  IconButton,
  IconButtonProps,
  styled,
  SvgIconProps,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "iconColor",
})<{ iconColor?: string }>(({ theme, iconColor }) => ({
  color: iconColor ?? theme.palette.text.black,
  padding: 0,
}));

const StyledHomeIcon = styled(HomeIcon)<SvgIconProps>(
  () => ({
    fontSize: "30px",
  })
);

interface Props extends IconButtonProps {
  iconProps?: SvgIconProps;
  iconColor?: string;
}

export const NavigateHomeButton: React.FC<Props> = ({
  iconProps,
  iconColor,
  ...buttonProps
}) => {
  return (
    <StyledIconButton {...buttonProps} iconColor={iconColor}>
      <StyledHomeIcon {...iconProps} />
    </StyledIconButton>
  );
};
